var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{attrs:{"value":_vm.value2,"readonly":"readonly"}})
}
var staticRenderFns = []

export { render, staticRenderFns }